
import { useState } from 'react';

export function ContactSection() {
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    bairro: '',
    tipoVazamento: '',
    mensagem: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const message = `Olá! Gostaria de solicitar um orçamento:
    
Nome: ${formData.nome}
WhatsApp: ${formData.telefone}
Bairro: ${formData.bairro}
Tipo de Vazamento: ${formData.tipoVazamento}
${formData.mensagem ? `Mensagem: ${formData.mensagem}` : ''}

Aguardo retorno. Obrigado!`;

    const whatsappUrl = `https://wa.me/5511948948561?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="orcamento" className="py-16 sm:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 animate-fade-in">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Solicite seu Orçamento</h2>
            <p className="text-lg text-slate-600">
              Preencha o formulário abaixo e entraremos em contato rapidamente
            </p>
          </div>
          
          <form onSubmit={handleSubmit} className="bg-slate-50 rounded-lg p-6 sm:p-8 shadow-lg animate-fade-in-up">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mb-6">
              <div className="space-y-2">
                <label className="text-sm font-medium leading-none text-slate-700" htmlFor="nome">
                  Nome completo *
                </label>
                <input 
                  className="flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm" 
                  id="nome"
                  name="nome"
                  placeholder="Seu nome" 
                  value={formData.nome}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="space-y-2">
                <label className="text-sm font-medium leading-none text-slate-700" htmlFor="telefone">
                  WhatsApp *
                </label>
                <input 
                  type="tel" 
                  className="flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm" 
                  id="telefone"
                  name="telefone"
                  placeholder="(11) 99999-9999" 
                  value={formData.telefone}
                  onChange={handleChange}
                  required 
                />
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mb-6">
              <div className="space-y-2">
                <label className="text-sm font-medium leading-none text-slate-700" htmlFor="bairro">
                  Bairro *
                </label>
                <input 
                  className="flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm" 
                  id="bairro"
                  name="bairro"
                  placeholder="Seu bairro" 
                  value={formData.bairro}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="space-y-2">
                <label className="text-sm font-medium leading-none text-slate-700" htmlFor="tipoVazamento">
                  Tipo de Vazamento *
                </label>
                <select 
                  className="flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 pr-8"
                  id="tipoVazamento"
                  name="tipoVazamento"
                  value={formData.tipoVazamento}
                  onChange={handleChange}
                  required
                >
                  <option value="">Selecione</option>
                  <option value="hidraulico">Vazamento Hidráulico</option>
                  <option value="gas">Vazamento de Gás</option>
                  <option value="piscina">Vazamento em Piscina</option>
                  <option value="conta-alta">Investigação de Conta de Água</option>
                  <option value="infiltracao">Infiltração</option>
                  <option value="outro">Outro</option>
                </select>
              </div>
            </div>
            
            <div className="space-y-2 mb-6">
              <label className="text-sm font-medium leading-none text-slate-700" htmlFor="mensagem">
                Mensagem (opcional)
              </label>
              <textarea 
                className="flex min-h-[80px] w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm ring-offset-background placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" 
                id="mensagem"
                name="mensagem"
                placeholder="Descreva brevemente o problema..." 
                rows={4}
                value={formData.mensagem}
                onChange={handleChange}
              />
            </div>
            
            <button 
              type="submit"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 bg-blue-800 text-white hover:bg-blue-900 shadow-lg hover:shadow-xl font-bold rounded-md px-8 w-full h-12 sm:h-14 text-base sm:text-lg"
            >
              Solicitar Orçamento Agora
            </button>
            
            <p className="text-sm text-slate-500 text-center mt-4">
              Ao enviar, você concorda em receber contato via WhatsApp.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
}
